<script setup lang="ts">
import {ref, onMounted} from 'vue';
import {useApi} from '@/ts/composables/stateful/use-api';
import LoadingError from '@/vue/templates/loading-error.vue';

const api = useApi();
const instructionsForUseHtml = ref<string>('');
const loading = ref(true);
const error = ref<string | null>(null);

async function fetchInstructionsForUse(): Promise<void> {
  loading.value = true;
  error.value = null;
  try {
    const legalDocs = await api.public.getLegalDocs();
    if (legalDocs?.instructionsForUse?.legalCopyHTML) {
      instructionsForUseHtml.value = legalDocs.instructionsForUse.legalCopyHTML;
    } else {
      error.value = 'Instructions for use not found.';
    }
  } catch (_e) {
    error.value = 'Failed to load instructions for use.';
  } finally {
    loading.value = false;
  }
}

onMounted(() => {
  void fetchInstructionsForUse();
});
</script>

<template>
  <loading-error
    id="instructions-for-use-page"
    :loading="loading"
    :error="error"
    type="page"
  >
    <div class="instructions-for-use-page">
      <div v-safe-html="instructionsForUseHtml" class="instructions-for-use-content"/>
    </div>
  </loading-error>
</template>

<style lang="scss" scoped>
.instructions-for-use-page {
  max-width: 800px;
  margin: 2rem auto;
  padding: 1rem;
}

.instructions-for-use-content {
  :deep(a) {
    color: var(--Functional-wl-link-active);
    text-decoration: underline;

    &:visited {
      color: var(--Functional-wl-active-link);
    }

    &:hover,
    &:focus-visible {
      text-decoration: none;
    }
  }

  :deep(img) {
    @include dark-mode {
      filter: invert(1);
    }
  }
}
</style>
